import React,{useState,}from 'react'
import { Modal,Form,Input, Button,message, DatePicker,} from 'antd';
import { useBnsFanKuiJianChaAddMutation } from '../../store/ReactWebSiteApi';
import GetUser from '../../cpn/GetUser';
import GetUserDept from '../../cpn/GetUserDept';
import MediaForm from '../media/MediaForm';
import dayjs from 'dayjs';
function FeedbackAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsFanKuiJianChaAddMutation()
    const [info,setInfo] = useState({
        bjswd_content:'',
    });
    return (
            <>
                <Button
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >新增</Button>
                <Modal
                    width={1000}
                    open={open}
                    title='新增反馈检查'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                  
                                    "bfkjc_cid" : localStorage.getItem('eu_id'),
                                    "bfkjc_cname" : localStorage.getItem('eu_name'),
                                    "bfkjc_dept_id" : info.bfkjc_dept_id,
                                    "bfkjc_dept_name" : info.bfkjc_dept_name,
                                    "bfkjc_e_id" : localStorage.getItem('e_id'),
                                    "bfkjc_fuzhuren_id" : info.bfkjc_fuzhuren_id,
                                    "bfkjc_fuzhuren_name" : info.bfkjc_fuzhuren_name,
                                    "bfkjc_jihuariqi" : info.bfkjc_jihuariqi,
                                    "bfkjc_meijie_id" : info.bfkjc_meijie_id,
                                    "bfkjc_meijie_name" : info.bfkjc_meijie_name,
                                    "bfkjc_name" : info.bfkjc_name,      
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bfkjc_dept_id:e,bfkjc_dept_name:f}))
                            }}
                        />                     
                        <MediaForm
                            wrapperCol={{span:10}}
                            required
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bfkjc_meijie_id:e,bfkjc_meijie_name:f.label}))
                            }}
                        />
                        <GetUser
                            label='负责人'
                            required
                            wrapperCol={{span:10}} 
                            getUser={(e,f) => {
                                setInfo(prevState=>({...prevState,bfkjc_fuzhuren_id:e,bfkjc_fuzhuren_name:f}))
                            }}
                        />
                        <Form.Item
                            wrapperCol={{span:20}} 
                            style={{marginBottom:"0"}}
                            label='计划日期'required
                        >
                            <Form.Item name="date">
                                <DatePicker 
                                     onChange={(e) => {setInfo(prevState=>({...prevState,bfkjc_jihuariqi:dayjs(e).format('YYYY-MM-DD')}))}} 
                                />
                            </Form.Item>
                        </Form.Item>
                        <Form.Item name="name" label='检查内容' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bfkjc_name:e.target.value}))}}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
            </>
        )
}

export default FeedbackAdd